import React from 'react';
import './RoleSelectionModal.css';

const RoleSelectionModal = ({ onRoleSelected, onClose, loading }) => {
  const handleRoleClick = (role) => {
    if (!loading) {
      onRoleSelected(role);
    }
  };

  return (
    <div className="role-modal-overlay" onClick={onClose}>
      <div className="role-modal-content" onClick={(e) => e.stopPropagation()}>
        <button
          className="role-modal-close"
          onClick={onClose}
          disabled={loading}
          aria-label="Close"
        >
          ×
        </button>

        <div className="role-modal-header">
          <div className="role-modal-icon">👋</div>
          <h2>Welcome!</h2>
          <p>Are you here to learn or teach?</p>
        </div>

        <div className="role-modal-options">
          <button
            className="role-option-button student-option"
            onClick={() => handleRoleClick('student')}
            disabled={loading}
          >
            <div className="role-option-icon">🎓</div>
            <div className="role-option-content">
              <h3>I'm a Student</h3>
              <p>Practice languages, create flashcards</p>
            </div>
            <div className="role-option-arrow">→</div>
          </button>

          <button
            className="role-option-button teacher-option"
            onClick={() => handleRoleClick('teacher')}
            disabled={loading}
          >
            <div className="role-option-icon">👨‍🏫</div>
            <div className="role-option-content">
              <h3>I'm a Teacher</h3>
              <p>Help students learn, join video sessions</p>
            </div>
            <div className="role-option-arrow">→</div>
          </button>
        </div>

        {loading && (
          <div className="role-modal-loading">
            <div className="spinner"></div>
            <p>Creating your account...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RoleSelectionModal;
